
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M0.70998 2.39003C0.31998 2.78003 0.31998 3.41003 0.70998 3.80003L1.99998 5.10003V19C1.99998 20.1 2.89998 21 3.99998 21H17.9L20.19 23.29C20.58 23.68 21.21 23.68 21.6 23.29C21.99 22.9 21.99 22.27 21.6 21.88L2.11998 2.39003C1.72998 2.00003 1.09998 2.00003 0.70998 2.39003ZM5.99998 19H3.99998V17H5.99998V19ZM5.99998 15H3.99998V13H5.99998V15ZM3.99998 11V9.00003H5.99998V11H3.99998ZM9.99998 19H7.99998V17H9.99998V19ZM7.99998 15V13H9.99998V15H7.99998ZM12 19V17H13.9L15.9 19H12ZM7.99998 5.00003H9.99998V7.00003H9.54998L12 9.45003V9.00003H19C19.55 9.00003 20 9.45003 20 10V17.45L22 19.45V9.00003C22 7.90003 21.1 7.00003 20 7.00003H12V5.00003C12 3.90003 11.1 3.00003 9.99998 3.00003H5.54998L7.99998 5.45003V5.00003ZM16 11H18V13H16V11Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-domain-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDomainDisabled

    ```js
    <b-new-b-icon-domain-disabled />
    ```
</docs>


